// extracted by mini-css-extract-plugin
export default {"wrapper":"orderScheduleNotices_wrapper__XsaAq","closedDayNotice":"orderScheduleNotices_closedDayNotice__K+jKM"};